import {Enumify} from 'enumify-ts';

class CustomerVehicleHireStatusType extends Enumify<CustomerVehicleHireStatusType>() {

    static SCHEDULED = new CustomerVehicleHireStatusType("SCHEDULED", "#06e6f5");
    static TO_BE_RESCHEDULED = new CustomerVehicleHireStatusType("TO BE RESCHEDULED", "#f2930c");
    static STARTED = new CustomerVehicleHireStatusType("STARTED", "#2db7f5");
    static CANCELLED = new CustomerVehicleHireStatusType("CANCELLED", "#aaa");
    static COMPLETED = new CustomerVehicleHireStatusType("COMPLETED", "#87d068");
    static _ = CustomerVehicleHireStatusType._closeEnum();

    constructor(
        public description: string,
        public colour: string
    ) {
        super();
    }

}

export default CustomerVehicleHireStatusType;
